import { render, staticRenderFns } from "./ChemCPP1210PQ1_Q1.vue?vue&type=template&id=0828523e&"
import script from "./ChemCPP1210PQ1_Q1.vue?vue&type=script&lang=js&"
export * from "./ChemCPP1210PQ1_Q1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
